import React from 'react'
import { useSelector } from 'react-redux'
import { SelectProps } from 'antd'
import FormulaSelect from './FormulaSelect'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'

const CtxFormulaSelect: React.FC<SelectProps> = props => {
  const companyId = useSelector(contextCompanyIdSelector)
  return <FormulaSelect {...props} companyId={companyId} />
}

export default CtxFormulaSelect
